import _regeneratorRuntime from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { ConsoleLogger as Logger } from './Logger';
import { StorageHelper } from './StorageHelper';
import { AWS } from './Facet';
import { makeQuerablePromise } from './JS';
import { FacebookOAuth, GoogleOAuth } from './OAuthHelper';
import { Amplify } from './Amplify';
var logger = new Logger('Credentials');
export var CredentialsClass = /*#__PURE__*/function () {
  function CredentialsClass(config) {
    _classCallCheck(this, CredentialsClass);

    this._gettingCredPromise = null;
    this._refreshHandlers = {};
    this.configure(config);
    this._refreshHandlers['google'] = GoogleOAuth.refreshGoogleToken;
    this._refreshHandlers['facebook'] = FacebookOAuth.refreshFacebookToken;
  }

  _createClass(CredentialsClass, [{
    key: "getCredSource",
    value: function getCredSource() {
      return this._credentials_source;
    }
  }, {
    key: "configure",
    value: function configure(config) {
      if (!config) return this._config || {};
      this._config = Object.assign({}, this._config, config);
      var refreshHandlers = this._config.refreshHandlers; // If the developer has provided an object of refresh handlers,
      // then we can merge the provided handlers with the current handlers.

      if (refreshHandlers) {
        this._refreshHandlers = Object.assign({}, this._refreshHandlers, refreshHandlers);
      }

      this._storage = this._config.storage;

      if (!this._storage) {
        this._storage = new StorageHelper().getStorage();
      }

      this._storageSync = Promise.resolve();

      if (typeof this._storage['sync'] === 'function') {
        this._storageSync = this._storage['sync']();
      }

      return this._config;
    }
  }, {
    key: "get",
    value: function get() {
      logger.debug('getting credentials');
      return this._pickupCredentials();
    }
  }, {
    key: "_pickupCredentials",
    value: function _pickupCredentials() {
      logger.debug('picking up credentials');

      if (!this._gettingCredPromise || !this._gettingCredPromise.isPending()) {
        logger.debug('getting new cred promise');

        if (AWS.config && AWS.config.credentials && AWS.config.credentials instanceof AWS.Credentials) {
          this._gettingCredPromise = makeQuerablePromise(this._setCredentialsFromAWS());
        } else {
          this._gettingCredPromise = makeQuerablePromise(this._keepAlive());
        }
      } else {
        logger.debug('getting old cred promise');
      }

      return this._gettingCredPromise;
    }
  }, {
    key: "_keepAlive",
    value: function _keepAlive() {
      logger.debug('checking if credentials exists and not expired');
      var cred = this._credentials;

      if (cred && !this._isExpired(cred)) {
        logger.debug('credentials not changed and not expired, directly return');
        return Promise.resolve(cred);
      }

      logger.debug('need to get a new credential or refresh the existing one');

      if (Amplify.Auth && typeof Amplify.Auth.currentUserCredentials === 'function') {
        return Amplify.Auth.currentUserCredentials();
      } else {
        return Promise.reject('No Auth module registered in Amplify');
      }
    }
  }, {
    key: "refreshFederatedToken",
    value: function refreshFederatedToken(federatedInfo) {
      var _this = this;

      logger.debug('Getting federated credentials');
      var provider = federatedInfo.provider,
          user = federatedInfo.user;
      var token = federatedInfo.token;
      var expires_at = federatedInfo.expires_at;
      var identity_id = federatedInfo.identity_id;
      var that = this;
      logger.debug('checking if federated jwt token expired');

      if (expires_at > new Date().getTime()) {
        // if not expired
        logger.debug('token not expired');
        return this._setCredentialsFromFederation({
          provider: provider,
          token: token,
          user: user,
          identity_id: identity_id,
          expires_at: expires_at
        });
      } else {
        // if refresh handler exists
        if (that._refreshHandlers[provider] && typeof that._refreshHandlers[provider] === 'function') {
          logger.debug('getting refreshed jwt token from federation provider');
          return that._refreshHandlers[provider]().then(function (data) {
            logger.debug('refresh federated token sucessfully', data);
            token = data.token;
            identity_id = data.identity_id;
            expires_at = data.expires_at;
            return that._setCredentialsFromFederation({
              provider: provider,
              token: token,
              user: user,
              identity_id: identity_id,
              expires_at: expires_at
            });
          }).catch(function (e) {
            logger.debug('refresh federated token failed', e);

            _this.clear();

            return Promise.reject('refreshing federation token failed: ' + e);
          });
        } else {
          logger.debug('no refresh handler for provider:', provider);
          this.clear();
          return Promise.reject('no refresh handler for provider');
        }
      }
    }
  }, {
    key: "_isExpired",
    value: function _isExpired(credentials) {
      if (!credentials) {
        logger.debug('no credentials for expiration check');
        return true;
      }

      logger.debug('is this credentials expired?', credentials);
      var ts = new Date().getTime();
      var delta = 10 * 60 * 1000; // 10 minutes

      var expired = credentials.expired,
          expireTime = credentials.expireTime;

      if (!expired && expireTime > ts + delta) {
        return false;
      }

      return true;
    }
  }, {
    key: "_setCredentialsForGuest",
    value: function _setCredentialsForGuest() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var attempted, _this$_config, identityPoolId, region, mandatorySignIn, identityId, credentials, that;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                attempted = false;
                logger.debug('setting credentials for guest');
                _this$_config = this._config, identityPoolId = _this$_config.identityPoolId, region = _this$_config.region, mandatorySignIn = _this$_config.mandatorySignIn;

                if (!mandatorySignIn) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", Promise.reject('cannot get guest credentials when mandatory signin enabled'));

              case 5:
                if (identityPoolId) {
                  _context2.next = 8;
                  break;
                }

                logger.debug('No Cognito Federated Identity pool provided');
                return _context2.abrupt("return", Promise.reject('No Cognito Federated Identity pool provided'));

              case 8:
                identityId = undefined;
                _context2.prev = 9;
                _context2.next = 12;
                return this._storageSync;

              case 12:
                identityId = this._storage.getItem('CognitoIdentityId-' + identityPoolId);
                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](9);
                logger.debug('Failed to get the cached identityId', _context2.t0);

              case 18:
                credentials = new AWS.CognitoIdentityCredentials({
                  IdentityPoolId: identityPoolId,
                  IdentityId: identityId ? identityId : undefined
                }, {
                  region: region
                });
                that = this;
                return _context2.abrupt("return", this._loadCredentials(credentials, 'guest', false, null).then(function (res) {
                  return res;
                }).catch(function (e) {
                  return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var newCredentials;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(e.code === 'ResourceNotFoundException' && e.message === "Identity '".concat(identityId, "' not found.") && !attempted)) {
                              _context.next = 9;
                              break;
                            }

                            attempted = true;
                            logger.debug('Failed to load guest credentials');

                            this._storage.removeItem('CognitoIdentityId-' + identityPoolId);

                            credentials.clearCachedId();
                            newCredentials = new AWS.CognitoIdentityCredentials({
                              IdentityPoolId: identityPoolId,
                              IdentityId: undefined
                            }, {
                              region: region
                            });
                            return _context.abrupt("return", this._loadCredentials(newCredentials, 'guest', false, null));

                          case 9:
                            return _context.abrupt("return", e);

                          case 10:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, this);
                  }));
                }));

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[9, 15]]);
      }));
    }
  }, {
    key: "_setCredentialsFromAWS",
    value: function _setCredentialsFromAWS() {
      var credentials = AWS.config.credentials;
      logger.debug('setting credentials from aws');
      var that = this;

      if (credentials instanceof AWS.Credentials) {
        return Promise.resolve(credentials);
      } else {
        logger.debug('AWS.config.credentials is not an instance of AWS Credentials');
        return Promise.reject('AWS.config.credentials is not an instance of AWS Credentials');
      }
    }
  }, {
    key: "_setCredentialsFromFederation",
    value: function _setCredentialsFromFederation(params) {
      var provider = params.provider,
          token = params.token,
          identity_id = params.identity_id,
          user = params.user,
          expires_at = params.expires_at;
      var domains = {
        'google': 'accounts.google.com',
        'facebook': 'graph.facebook.com',
        'amazon': 'www.amazon.com',
        'developer': 'cognito-identity.amazonaws.com'
      }; // Use custom provider url instead of the predefined ones

      var domain = domains[provider] || provider;

      if (!domain) {
        return Promise.reject('You must specify a federated provider');
      }

      var logins = {};
      logins[domain] = token;
      var _this$_config2 = this._config,
          identityPoolId = _this$_config2.identityPoolId,
          region = _this$_config2.region;

      if (!identityPoolId) {
        logger.debug('No Cognito Federated Identity pool provided');
        return Promise.reject('No Cognito Federated Identity pool provided');
      }

      var credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: identityPoolId,
        IdentityId: identity_id,
        Logins: logins
      }, {
        region: region
      });
      return this._loadCredentials(credentials, 'federated', true, params);
    }
  }, {
    key: "_setCredentialsFromSession",
    value: function _setCredentialsFromSession(session) {
      logger.debug('set credentials from session');
      var idToken = session.getIdToken().getJwtToken();
      var _this$_config3 = this._config,
          region = _this$_config3.region,
          userPoolId = _this$_config3.userPoolId,
          identityPoolId = _this$_config3.identityPoolId;

      if (!identityPoolId) {
        logger.debug('No Cognito Federated Identity pool provided');
        return Promise.reject('No Cognito Federated Identity pool provided');
      }

      var key = 'cognito-idp.' + region + '.amazonaws.com/' + userPoolId;
      var logins = {};
      logins[key] = idToken;
      var credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: identityPoolId,
        Logins: logins
      }, {
        region: region
      });
      var that = this;
      return this._loadCredentials(credentials, 'userPool', true, null);
    }
  }, {
    key: "_loadCredentials",
    value: function _loadCredentials(credentials, source, authenticated, info) {
      var _this3 = this;

      var that = this;
      var identityPoolId = this._config.identityPoolId;
      return new Promise(function (res, rej) {
        credentials.get(function (err) {
          return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
            var user, provider, token, expires_at, identity_id;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    if (!err) {
                      _context3.next = 4;
                      break;
                    }

                    logger.debug('Failed to load credentials', credentials);
                    rej(err);
                    return _context3.abrupt("return");

                  case 4:
                    logger.debug('Load credentials successfully', credentials);
                    that._credentials = credentials;
                    that._credentials.authenticated = authenticated;
                    that._credentials_source = source;

                    if (source === 'federated') {
                      user = Object.assign({
                        id: this._credentials.identityId
                      }, info.user);
                      provider = info.provider, token = info.token, expires_at = info.expires_at, identity_id = info.identity_id;

                      try {
                        this._storage.setItem('aws-amplify-federatedInfo', JSON.stringify({
                          provider: provider,
                          token: token,
                          user: user,
                          expires_at: expires_at,
                          identity_id: identity_id
                        }));
                      } catch (e) {
                        logger.debug('Failed to put federated info into auth storage', e);
                      } // the Cache module no longer stores federated info
                      // this is just for backward compatibility


                      if (Amplify.Cache && typeof Amplify.Cache.setItem === 'function') {
                        Amplify.Cache.setItem('federatedInfo', {
                          provider: provider,
                          token: token,
                          user: user,
                          expires_at: expires_at,
                          identity_id: identity_id
                        }, {
                          priority: 1
                        });
                      } else {
                        logger.debug('No Cache module registered in Amplify');
                      }
                    }

                    if (!(source === 'guest')) {
                      _context3.next = 19;
                      break;
                    }

                    _context3.prev = 10;
                    _context3.next = 13;
                    return this._storageSync;

                  case 13:
                    this._storage.setItem('CognitoIdentityId-' + identityPoolId, credentials.identityId);

                    _context3.next = 19;
                    break;

                  case 16:
                    _context3.prev = 16;
                    _context3.t0 = _context3["catch"](10);
                    logger.debug('Failed to cache identityId', _context3.t0);

                  case 19:
                    res(that._credentials);
                    return _context3.abrupt("return");

                  case 21:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, this, [[10, 16]]);
          }));
        });
      });
    }
  }, {
    key: "set",
    value: function set(params, source) {
      if (source === 'session') {
        return this._setCredentialsFromSession(params);
      } else if (source === 'federation') {
        return this._setCredentialsFromFederation(params);
      } else if (source === 'guest') {
        return this._setCredentialsForGuest();
      } else {
        logger.debug('no source specified for setting credentials');
        return Promise.reject('invalid source');
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this$_config4, identityPoolId, region, credentials;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$_config4 = this._config, identityPoolId = _this$_config4.identityPoolId, region = _this$_config4.region;

                if (identityPoolId) {
                  // work around for cognito js sdk to ensure clearCacheId works
                  credentials = new AWS.CognitoIdentityCredentials({
                    IdentityPoolId: identityPoolId
                  }, {
                    region: region
                  });
                  credentials.clearCachedId();
                }

                this._credentials = null;
                this._credentials_source = null;

                this._storage.removeItem('aws-amplify-federatedInfo'); // the Cache module no longer stores federated info
                // this is just for backward compatibility


                if (!(Amplify.Cache && typeof Amplify.Cache.setItem === 'function')) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 8;
                return Amplify.Cache.removeItem('federatedInfo');

              case 8:
                _context4.next = 11;
                break;

              case 10:
                logger.debug('No Cache module registered in Amplify');

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */

  }, {
    key: "shear",
    value: function shear(credentials) {
      return {
        accessKeyId: credentials.accessKeyId,
        sessionToken: credentials.sessionToken,
        secretAccessKey: credentials.secretAccessKey,
        identityId: credentials.identityId,
        authenticated: credentials.authenticated
      };
    }
  }]);

  return CredentialsClass;
}();
export var Credentials = new CredentialsClass(null);
/**
 * @deprecated use named import
 */

export default Credentials;